import React, { useState, useCallback } from 'react';
import { VStack, HStack, Text, Button, Icon, Spinner, useColorModeValue } from '@chakra-ui/react';
import { FiRefreshCw } from 'react-icons/fi';
import { httpsCallable } from 'firebase/functions';
import { functionsUsEast1 } from '../../../utils/init-firebase';

export default function AriveCreditCard({ ariveId }) {
  const [creditData, setCreditData] = useState(null);
  const [loading, setLoading] = useState(false);
  const mutedColor = useColorModeValue('gray.500', 'gray.400');

  const fetchCredit = useCallback(async () => {
    if (!ariveId) return;
    setLoading(true);
    try {
      const fn = httpsCallable(functionsUsEast1, 'getAriveCreditInfo');
      const result = await fn({ loanId: ariveId });
      setCreditData(result.data?.creditScores || []);
    } catch (_) {
      setCreditData([]);
    } finally {
      setLoading(false);
    }
  }, [ariveId]);

  if (!creditData) {
    return (
      <Button size="xs" variant="ghost" leftIcon={<Icon as={FiRefreshCw} />} onClick={fetchCredit} isLoading={loading}>
        Load Credit Scores
      </Button>
    );
  }

  if (creditData.length === 0) {
    return <Text fontSize="xs" color={mutedColor}>No credit data available</Text>;
  }

  return (
    <VStack align="stretch" spacing={2}>
      {creditData.map((borrower, i) => (
        <VStack key={i} align="stretch" spacing={1}>
          <Text fontSize="xs" fontWeight="semibold">{borrower.BorrowerName} ({borrower.BorrowerRole})</Text>
          {borrower.CreditScoreDetails && (
            <HStack spacing={4}>
              {borrower.CreditScoreDetails.experian != null && (
                <VStack spacing={0}><Text fontSize="10px" color={mutedColor}>EXP</Text><Text fontSize="sm" fontWeight="bold">{borrower.CreditScoreDetails.experian}</Text></VStack>
              )}
              {borrower.CreditScoreDetails.equifax != null && (
                <VStack spacing={0}><Text fontSize="10px" color={mutedColor}>EQF</Text><Text fontSize="sm" fontWeight="bold">{borrower.CreditScoreDetails.equifax}</Text></VStack>
              )}
              {borrower.CreditScoreDetails.transunion != null && (
                <VStack spacing={0}><Text fontSize="10px" color={mutedColor}>TU</Text><Text fontSize="sm" fontWeight="bold">{borrower.CreditScoreDetails.transunion}</Text></VStack>
              )}
            </HStack>
          )}
        </VStack>
      ))}
    </VStack>
  );
}
